import Config from '../Config';
import { RestService } from './RestService';

export const StoreTransactionService = {
    getStoreTransactions: async function(start, numberItems, startdate, enddate, project_id, txn_type, item_id, user_id, sort, direction){
        return RestService.get(`${Config.get_store_transactions}from=${start}&offset=${numberItems}&sort=${sort}&direction=${direction}${ project_id ? `&project_id=${project_id}` : ''}${ startdate ? `&startdate=${startdate}` : ''}${ enddate ? `&enddate=${enddate}` : ''}${ user_id ? `&user_id=${user_id}` : ''}${ txn_type ? `&txn_type=${txn_type}` : ''}${ item_id ? `&item_id=${item_id}` : ''}`, {})
        .then(response => response.json());
    },
    getTotalCount: async function(project_id, item_id, txn_type, user_id, startdate, enddate) {
        return RestService.get(`${Config.total_count}data_type=STORE_TRANSACTIONS${ project_id ? `&project_id=${project_id}` : ''}${ user_id ? `&user_id=${user_id}` : ''}${ item_id ? `&item_id=${item_id}` : ''}${ txn_type ? `&txn_type=${txn_type}` : ''}${ startdate ? `&startdate=${startdate}` : ''}${ enddate ? `&enddate=${enddate}` : ''}`, {})
        .then(response => response.json());
    },
    createTransaction: async function(headers, body){
        return RestService.post(`${Config.create_store_transaction}`, headers, body)
        .then(response => response.json());
    },
    getStoreTransactionsForProject: async function(id) {
        return RestService.get(`${Config.get_project_store_transactions}id=${id}`, {})
        .then(response => response.json());
    }
    // changeProjectStatus: async function(headers, body){
    //     return RestService.post(`${Config.change_project_status}`, headers, body);
    //     // .then(response => response.json());
    // },
};